module.exports = __webpack_public_path__ + "static/desktop-footer-logo-6b8ddd6bcf657d290beb2d61946b5bf7.png";